module.exports = __webpack_public_path__ + "img/bg.8adcea2c.jpg";